import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserCog, Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const inputCls =
  "w-full bg-[#090a0f] border border-[#232838] rounded-md px-3 py-2.5 text-sm text-white focus:outline-none focus:border-[#8b5cf6] transition-colors";

export default function Cuenta() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== confirm) {
      setError("Las contraseñas nuevas no coinciden.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Contraseña actualizada. Vuelve a iniciar sesión.");
      await logout();
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="account-page" className="max-w-md">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-2">Cuenta</h1>
      <p className="text-sm text-slate-500 mb-6 flex items-center gap-2">
        <UserCog className="w-4 h-4" />
        <span data-testid="account-email">{user?.email}</span>
      </p>

      <form onSubmit={submit} className="card-glow rounded-lg p-6 space-y-4" data-testid="change-password-form">
        <div className="flex items-center gap-2 mb-1">
          <KeyRound className="w-4 h-4 text-[#8b5cf6]" />
          <h2 className="text-lg font-semibold">Cambiar contraseña</h2>
        </div>

        <div>
          <label className="block text-[10px] font-mono2 uppercase tracking-widest text-slate-500 mb-1.5">Contraseña actual</label>
          <input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)}
            data-testid="current-password-input" className={inputCls} autoComplete="current-password" />
        </div>
        <div>
          <label className="block text-[10px] font-mono2 uppercase tracking-widest text-slate-500 mb-1.5">Nueva contraseña (mín. 8 caracteres)</label>
          <input type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)}
            data-testid="new-password-input" className={inputCls} autoComplete="new-password" />
        </div>
        <div>
          <label className="block text-[10px] font-mono2 uppercase tracking-widest text-slate-500 mb-1.5">Confirmar nueva contraseña</label>
          <input type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)}
            data-testid="confirm-password-input" className={inputCls} autoComplete="new-password" />
        </div>

        {error && (
          <div data-testid="change-password-error" className="text-xs text-red-400 bg-red-950/40 border border-red-900 rounded-md px-3 py-2">
            {error}
          </div>
        )}

        <button type="submit" disabled={saving} data-testid="change-password-submit"
          className="w-full bg-[#8b5cf6] hover:bg-[#7c3aed] disabled:opacity-50 text-white text-sm font-semibold rounded-md py-2.5 transition-colors flex items-center justify-center gap-2">
          {saving && <Loader2 className="w-4 h-4 animate-spin" />}
          Actualizar contraseña
        </button>

        <p className="text-[11px] text-slate-600 leading-relaxed">
          Al cambiarla aquí, la contraseña de backend/.env (ADMIN_PASSWORD) dejará de aplicarse: la app ya no la sobrescribe en reinicios. Se cerrará tu sesión.
        </p>
      </form>
    </div>
  );
}
